/**
 * Where the API lives. One env var decides it: REACT_APP_BASE_SERVER_URL.
 *
 * The client also needs the `/api/v1` root for endpoints outside the
 * flashtools app (users, integrations). That root used to come from its own
 * env var with its own hardcoded fallback, which is how the cutover to a new
 * Render workspace half-happened: REACT_APP_BASE_SERVER_URL was repointed,
 * REACT_APP_INTEGRATIONS_BASE_URL never existed on the new service, and the
 * profile, connections, transfer and DICE-subscription calls kept going to
 * the suspended host and dying on CORS. Deriving the root from the one URL
 * that is actually configured makes a repoint a single change.
 */
// The new Render workspace's host. The old oneclicktixcore.onrender.com was
// suspended at the 2026-09-08 cutover, so a build with no env var must not
// fall back to it.
const DEFAULT_FLASHTOOLS_BASE_URL = 'https://oneclicktixcore-mig.onrender.com/api/v1/flashtools';

export const FLASHTOOLS_BASE_URL: string =
  process.env.REACT_APP_BASE_SERVER_URL || DEFAULT_FLASHTOOLS_BASE_URL;

/** `https://host/api/v1`, derived from the flashtools base unless explicitly overridden. */
export const API_V1_BASE_URL: string =
  process.env.REACT_APP_INTEGRATIONS_BASE_URL ||
  FLASHTOOLS_BASE_URL.replace(/\/flashtools\/?$/, '');
